import Ajax from "@/lib/ajax";

interface GetListParams {
  subdistrict?: number;
  IsDelivery?: boolean;
  Sorting?: string;
  SkipCount?: number;
  MaxResultCount?: number;
}

export default {
  /**
   *  从高德获取 省市区信息
   */
  addChinaAddress(params: GetListParams) {
    return Ajax.get(`/api/OrderManagement/Address/addChinaAddress`, { params });
  },
  /**
   * 创建修改发货地区限制
   */
  updateAddress(limitAdderss, isdelivery) {
    let params = {
      isdelivery,
      limitAdderss,
    };
    return Ajax.put(`/api/OrderManagement/Address/updateAddress`, params);
  },
};
